import { render, staticRenderFns } from "./scoreAdd.vue?vue&type=template&id=aca5e4ee&scoped=true&"
import script from "./scoreAdd.vue?vue&type=script&lang=js&"
export * from "./scoreAdd.vue?vue&type=script&lang=js&"
import style0 from "./scoreAdd.vue?vue&type=style&index=0&id=aca5e4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5e4ee",
  null
  
)

export default component.exports